import { render, staticRenderFns } from "./PieCharCom.vue?vue&type=template&id=ab449e1e&"
import script from "./PieCharCom.vue?vue&type=script&lang=ts&"
export * from "./PieCharCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports